import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TeeButton } from '@/components/ui/tee-button';
import { TeeInput } from '@/components/ui/tee-input';

export interface ClarifySearchListProps {
  options: string[];
  disabled?: boolean;
  onSelect: (label: string) => void;
}

/** Type-to-filter picker for choices too numerous for chips (e.g. 25+ locations). */
export function ClarifySearchList({
  options,
  disabled = false,
  onSelect,
}: ClarifySearchListProps) {
  const { t } = useTranslation();
  const [query, setQuery] = useState('');

  const matches = useMemo(() => {
    const q = query.trim().toLowerCase();
    return q ? options.filter((o) => o.toLowerCase().includes(q)) : options;
  }, [options, query]);

  return (
    <div className="flex w-full flex-col gap-2">
      <TeeInput
        value={query}
        disabled={disabled}
        placeholder={t('assistant.chat.searchLocations')}
        aria-label={t('assistant.chat.searchLocations')}
        onChange={(e) => setQuery(e.target.value)}
      />
      <div
        className="flex max-h-[220px] flex-col gap-1 overflow-y-auto rounded-[6px] border border-[var(--border-default)] bg-[var(--background-card)] p-1"
        role="listbox"
      >
        {matches.length === 0 ? (
          <p className="px-2 py-1.5 text-[14px] text-[var(--text-content-sub-title)]">
            {t('assistant.chat.noLocationMatches')}
          </p>
        ) : (
          matches.map((opt) => (
            <TeeButton
              key={opt}
              variant="ghost"
              size="s"
              text={opt}
              disabled={disabled}
              onClick={() => onSelect(opt)}
            />
          ))
        )}
      </div>
    </div>
  );
}
